
























import { Component, Vue } from "vue-property-decorator";
import { EXIT_IMAGES } from "@/resources/constants/exitImages";
@Component({
  name: "exit-modal-component",
})
export default class ExitModalComponent extends Vue {
  EXIT_IMAGES = EXIT_IMAGES;
  showImage = null;
  mounted() {
    const index = Math.floor(Math.random() * EXIT_IMAGES.length);
    this.showImage = EXIT_IMAGES[index];
    const pusher = this.$store.getters["SystemStore/getPusher"];
    this.$store.dispatch("GraphicClientStore/exitNubiiAction");
    pusher.disconnect();
  }
  get active(): boolean {
    return this.$store.getters["SystemStore/getExitModal"];
  }
  backToNubii() {
    location.reload();
  }
}
